<template>
  <div>
    <div class="container-fluid featured-image">
      <div class="container featured-image-content">
        <div class="featured-text h-100">
          <div
            class="feature-content h-100 d-flex flex-column justify-content-center"
          >
            <div class="feature-header-wrapper">
              <p class="feature-header">KD Roofing</p>
              <p class="feature-header">Specialists For All Your Roofing Needs
              </p>
            </div>
            <div class="feature-sub-header-wrapper d-none d-md-block">
              <hr />
              <p class="feature-sub-header">
                Providing professional, second to none roofing services covering
                Norfolk, Suffolk, Cambridge and East Anglia.
              </p>
            </div>
            <div
              class="button-holder d-flex align-items-center justify-content-center justify-content-lg-end flex-column flex-md-row"
            >
              <router-link class="btn button-secondary" to="/contact/"
                >Contact Us</router-link
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="welcome-section-wrapper">
      <div class="welcome-section-bg">
        <div class="container">
          <div class="row">
            <div class="col-xl-6 col-md-12 welcome-section">
              <h1 class="welcome-header">Welcome to KD Roofing</h1>
              <hr align="left" />
              <p>
                <strong
                  >Customer Service is the forefront of every job we take on.
                  From consultation to completion you will be kept informed at
                  all times of the progression of the job.
                </strong>
              </p>
              <p>
                We endeavor to complete every job on time and within budget.
                Testimony to this is that most of our work comes from word of
                mouth recommendations. We are located in Hingham, Norfolk and can
                provide services both locally and nationally.
              </p>
            </div>
          </div>
        </div>
        <div class="welcome-section-image d-none d-xl-block"></div>
      </div>
      <div class="welcome-section-additional">
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              <ul>
                <li>More than 25 years experience</li>
                <li>Fully trained and qualified Roofers</li>
                <li>High level of workmanship</li>
                <li>Free, no obligation quotations available</li>
                <li>Highly recommended</li>
                <li>Competitively priced</li>
                <li>Fully insured</li>
                <li>Insurance work undertaken</li>
                <li>Reliable and trustworthy team</li>
                <li>Domestic and commercial work undertaken</li>
                <li>Quick response</li>
              </ul>
            </div>
            <div class="col-md-6">
              <p>
                Has your roof seen better days?<br />
                Is your roof looking tired and worn?<br />
                Do you need a new roof?<br />
                Maybe you just need the tiles or slates repairing.
              </p>
              <p>
                From minor roof repairs and new roof installations to loft
                conversions and building maintenance, we cover all domestic and
                commercial works.
              </p>
              <p>
                For your peace of mind all jobs that we completed are fully
                guaranteed, for more information please do not&nbsp;hesitate to
                contact us.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="services">
      <div class="container">
        <div class="d-sm-flex align-items-center services-heading-section">
          <div>
            <h2 class="text-center text-sm-left">Our Services</h2>
            <hr />
          </div>
          <router-link
            to="/services/"
            class="btn btn-primary-dark ml-auto d-none d-sm-inline"
            >View All</router-link
          >
        </div>
        <div class="row">
          <div
            v-for="(item, index) in services"
            :key="index"
            class="col-12 col-md-6 col-xl-4 service-card-col"
          >
            <Card
              :title="item.title"
              :description="item.description"
              :url="item.url"
              :image="item.image"
            />
          </div>
        </div>
      </div>
    </div>
    <GetInTouch />
    <div id="testimonials">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <h2>Our <br class="d-sm-none" />Testimonials</h2>
            <hr />
            <swiper :options="swiperOption">
              <!-- slides -->
              <swiper-slide>
                <div class="quote-content">
                  <p>
                    Outstanding job by Keith and his team ! A brand new roof
                    without any fuss or bother . The price was excellent, the
                    work faultless and the team were lovely ! We can’t recommend
                    them too highly.
                  </p>
                  <!-- <p class="author">- Lorem ipsum dolor sit amet</p> -->
                </div>
              </swiper-slide>
              <swiper-slide>
                <div class="quote-content">
                  <p>
                    Highly recommend. Absolutely faultless service from start
                    (quoting) to finish. We obtained several quotes from many
                    local roofing firms and KD Roofing stood out as the very
                    best. An excellent, trustworthy, responsive service and
                    competitively priced. Obtaining quotes from elsewhere turned
                    out to be a complete waste of time. I would recommend Keith
                    and his team to anyone.
                  </p>
                  <!-- <p class="author">- Aliquam tincidunt mauris eu risus</p> -->
                </div>
              </swiper-slide>
              <div
                class="swiper-pagination swiper-pagination-bullets"
                slot="pagination"
              ></div>
            </swiper>
            <span class="left-quote">&ldquo;</span>
            <span class="right-quote">&rdquo;</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "swiper/dist/css/swiper.css";
import Card from "../partials/Card";
import GetInTouch from "../partials/GetInTouch";

import { swiper, swiperSlide } from "vue-awesome-swiper";

export default {
  components: {
    swiper,
    swiperSlide,
    Card,
    GetInTouch,
  },
  name: "Home",
  data() {
    return {
      services: [
        {
          title: "Tiling",
          description:
            "From tiling large commercial housing developments to re-roofing domestic properties, we are able to assist with a diverse range of roof tiling needs.",
          url: "/services/",
          image: require("../../assets/images/services/tiling.png"),
        },
        {
          title: "Slate Work",
          description:
            "Our skilled team of slate roofing professionals have a great deal of experience of working with both reclaimed traditional slate roofs and other types of natural and man-made slates.",
          url: "/services/",
          image: require("../../assets/images/services/slate.png"),
        },
        {
          title: "Chimneys",
          description:
            "We offer a comprehensive chimney repair and maintenance service, our team of professionals have worked on every type of chimney imaginable.",
          url: "/services/",
          image: require("../../assets/images/services/chimneys.png"),
        },
        {
          title: "Flat Roofs",
          description:
            "We can install and repair Flat Roofs using high quality products ensuring the life of your roof is at it’s maximum.",
          url: "/services/",
          image: require("../../assets/images/services/flat-roofs.png"),
        },
        {
          title: "Facias & Guttering",
          description:
            "Once installed by KD Roofing this is an excellent way of giving your property an external face lift and relieve you of that constant maintenance issue needed with old timber roofline surrounds.",
          url: "/services/",
          image: require("../../assets/images/services/facias-and-guttering.png"),
        },
        {
          title: "Loft Conversions",
          description:
            "We can consult and perform full Loft Conversions, opening up extra space in your home.  Ensuring all building regulations are adhered to.",
          url: "/services/",
          image: require("../../assets/images/services/loft-conversions.png"),
        },
      ],
      swiperOption: {
        spaceBetween: 30,
        centeredSlides: true,
        autoHeight: false,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
      },
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Home.vue